import React, { FunctionComponent } from "react";
import { Environment, QueryRenderer } from "react-relay";
import { graphql } from "relay-runtime";
import {relayAuthEnvironment, relayGuestEnvironment} from "@/RelayEnvironment";
import LoadingElement from "@/Components/Loading/LoadingElement";
import {useSelector} from "react-redux";
import {selectLocale} from "@/Redux/App/AppReducer";
import TranslationGate from "@/Utils/TranslationGate";
import UserTokenMainView from "@/Domains/AuthenticationManagement/Usertoken/Views/UserTokenMainView";
import {
    UserTokenMainQueryRendererQuery
} from "@/Domains/UserManagement/User/QueryRenderer/__generated__/UserTokenMainQueryRendererQuery.graphql";

interface IUserTokenMainQueryRenderer {

}

const UserTokenMainQueryRenderer: FunctionComponent<IUserTokenMainQueryRenderer> = ({
                                                                          }): JSX.Element => {

    const language = useSelector(selectLocale);

    return (
        <QueryRenderer<UserTokenMainQueryRendererQuery>
            //@ts-ignore
            environment={relayGuestEnvironment() as Environment}
            query={graphql`
                query UserTokenMainQueryRendererQuery($lang: String!, $prefixes: [String]) {                
                    translationList(lang: $lang, prefixes: $prefixes) {
                        translations {
                            component
                            text
                        }
                    } 
                    languageList {
                        languages{
                            language
                            languageId
                        }       
                    }            
                }
            `}
            cacheConfig={{ force: true }}
            variables={{
                lang: language?.locale ?? language,
                prefixes: ["CRW6.userToken"]
            }}
            render={(result) => {
                if (!result.props) {
                    return <LoadingElement />;
                }
                return (
                    <TranslationGate translationList={result.props?.translationList} prefix={"userToken"}>
                        <UserTokenMainView
                            viewData={result.props}
                        />
                    </TranslationGate>
                );
            }}
        />
    );
};

export default UserTokenMainQueryRenderer;
